import { reatomAsync, withAbort } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import {
  currentCursorAtom,
  filterAtom,
  sortAtom,
} from "src/pages/ProductPage/store/atoms";
import { toCreatedAtRange } from "src/pages/ProductPage/utils";
import { productSelectionStore } from "src/store/atoms";
import { toastHandler } from "src/util";

import { fillCountAtom } from "../../components/FillProductSelectionButton/store/atoms/fillCountAtom";

export const fillProductSelection = reatomAsync(async (ctx) => {
  const filterData = ctx.get(filterAtom);
  const sortData = ctx.get(sortAtom);

  const selectedProductSample = ctx.get(
    productSelectionStore.currentSelectionAtom,
  );
  const cursor = ctx.get(currentCursorAtom);
  const count = ctx.get(fillCountAtom);

  return API.productSelectionApi
    .productSelectionControllerFillByFilters(
      {
        selectionId: selectedProductSample?.id || 0,
        count,
        searchProductsRequestDto: {
          query: filterData.search || undefined,
          categories: filterData.categoryIds?.map(Number),
          brands: filterData.brandIds?.map(Number),
          priceMin: filterData.priceFrom,
          priceMax: filterData.priceTo,
          ...toCreatedAtRange(filterData),
          currency: filterData.currency,
          cursor,
          sources: filterData.sources,
          includeCustom: filterData.includeCustom,
          sortBy: sortData?.type,
          excludeSelectionIds: filterData.excludeSamples?.map(Number),
        },
      },
      { signal: ctx.controller.signal },
    )
    .then(async (d) => {
      if (d.data) {
        await ctx.schedule(() => {
          productSelectionStore.setCurrentSelectionAction(ctx, d.data);
        });
      }

      toastHandler.success({
        name: "fillProductSample",
        title: "Заполнение выборки",
        content: `Выборка: ${d?.data?.name}, успешно заполнена товарами`,
      });
    });
}, "fillProductSelectionRequest").pipe(withAbort(), withIsLoadingAtom());
